// API URLs by environment
// NODE_ENV is injected by webpack DefinePlugin at build time
const API_URLS = {
    // Local development
    development: 'http://localhost:3000',
    // Deployed environments
    e2e: 'https://backend.hof2026-e2e.a.intuit.com',
    qal: 'https://backend.hof2026-qal.a.intuit.com',
    prd: 'https://backend.hof2026.a.intuit.com',
};
const STUDENT_PORTAL_URLS = {
    development: 'http://localhost:3000',
    e2e: 'https://hof2026-e2e.a.intuit.com/student',
    qal: 'https://hof2026-qal.a.intuit.com/student',
    prd: 'https://hof2026.intuit.com/student',
};
const SCHOOL_REGISTRATION_FORM_SCHEMA_URL = {
    development: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/school-registration-form/latest/school-registration-form.json',
    e2e: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/school-registration-form/latest/school-registration-form.json',
    qal: 'https://qalasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/school-registration-form/latest/school-registration-form.json',
    prd: 'https://prdasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/school-registration-form/latest/school-registration-form.json',
};
const COMMUNITY_REGISTRATION_FORM_SCHEMA_URL = {
    development: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/community-registration-form/latest/community-registration-form.json',
    e2e: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/community-registration-form/latest/community-registration-form.json',
    qal: 'https://qalasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/community-registration-form/latest/community-registration-form.json',
    prd: 'https://prdasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/community-registration-form/latest/community-registration-form.json',
};
const INDEPENDENT_REGISTRATION_FORM_SCHEMA_URL = {
    development: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/independent-registration-form/latest/independent-registration-form.json',
    e2e: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/independent-registration-form/latest/independent-registration-form.json',
    qal: 'https://qalasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/independent-registration-form/latest/independent-registration-form.json',
    prd: 'https://prdasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/independent-registration-form/latest/independent-registration-form.json',
};
const TEACHER_POST_REGISTRATION_SURVEY_URL = {
    development: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/educator-pre-survey/latest/educator-pre-survey.json',
    e2e: 'https://e2easset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/educator-pre-survey/latest/educator-pre-survey.json',
    qal: 'https://qalasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/educator-pre-survey/latest/educator-pre-survey.json',
    prd: 'https://prdasset.intuit4education.a.intuit.com/hof/events/hof-spring-2026/educator-pre-survey/latest/educator-pre-survey.json',
};
const REGISTRATION_DONE_URL = {
    development: 'http://intuit.com/houroffinance',
    e2e: 'http://intuit.com/houroffinance',
    qal: 'http://intuit.com/houroffinance',
    prd: 'http://intuit.com/houroffinance',
};
/**
 * Get the API URL for the current environment
 * process.env.NODE_ENV is replaced at build time by webpack DefinePlugin
 * @returns {string} The API base URL
 */
export const getApiUrl = () => {
    // NODE_ENV is injected by webpack DefinePlugin (literal replacement)
    const env = process.env.NODE_ENV || 'development';
    console.log('DEBUG: env', env);
    return API_URLS[env] || API_URLS.development;
};
export const getStudentPortalUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return STUDENT_PORTAL_URLS[env] || STUDENT_PORTAL_URLS.development;
};
/**
 * Check if current environment allows dev tools (step navigation, etc.)
 * Only enabled in development and e2e, NOT in qal or production
 */
export const isDevToolsEnabled = () => {
    const env = process.env.NODE_ENV || 'development';
    return env === 'development' || env === 'e2e';
};
export const getSchoolRegistrationFormSchemaUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return SCHOOL_REGISTRATION_FORM_SCHEMA_URL[env] || SCHOOL_REGISTRATION_FORM_SCHEMA_URL.development;
};
export const getCommunityRegistrationFormSchemaUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return COMMUNITY_REGISTRATION_FORM_SCHEMA_URL[env] || COMMUNITY_REGISTRATION_FORM_SCHEMA_URL.development;
};
export const getIndependentRegistrationFormSchemaUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return INDEPENDENT_REGISTRATION_FORM_SCHEMA_URL[env] || INDEPENDENT_REGISTRATION_FORM_SCHEMA_URL.development;
};
export const getTeacherPostRegistrationSurveyUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return TEACHER_POST_REGISTRATION_SURVEY_URL[env] || TEACHER_POST_REGISTRATION_SURVEY_URL.development;
};
export const getRegistrationDoneUrl = () => {
    const env = process.env.NODE_ENV || 'development';
    return REGISTRATION_DONE_URL[env] || REGISTRATION_DONE_URL.development;
};
// Re-export shared Turnstile config
export { getTurnstileSiteKey } from 'shared/utils/turnstileConfig';
